import React from 'react';

const Billing = () => {
  return <div>billing</div>;
};

export default Billing;
